var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearnByCollaboration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 63,
    viewBox: "0 0 68 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1618",
    "data-name": "Group 1618",
    transform: "translate(-340 -1755)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 68,
    height: 63,
    rx: 12,
    transform: "translate(340 1755)",
    fill: "#3488eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(353.75 1767.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M13.959,18.91a1.321,1.321,0,0,1-.823-.288L8.744,15.109a1.318,1.318,0,1,1,1.647-2.058l3.523,2.82,7.074-6.288a1.317,1.317,0,1,1,1.75,1.969l-7.9,7.025A1.314,1.314,0,0,1,13.959,18.91Z",
    transform: "translate(4.538 5.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M19.375,38.629a3.073,3.073,0,0,1-1.25-.264l-3.336-1.484A21.131,21.131,0,0,1,2.25,17.587v-6.7A3.058,3.058,0,0,1,4.783,7.863,28.378,28.378,0,0,0,10.12,6.39a28.529,28.529,0,0,0,7.381-4.2,3.021,3.021,0,0,1,3.747,0,28.5,28.5,0,0,0,7.381,4.2,28.445,28.445,0,0,0,6.713,1.679,1.317,1.317,0,1,1-.322,2.614,31.055,31.055,0,0,1-7.338-1.834,31.17,31.17,0,0,1-8.063-4.59.378.378,0,0,0-.49,0,31.19,31.19,0,0,1-8.064,4.59A31.02,31.02,0,0,1,5.233,10.46a.42.42,0,0,0-.348.425v6.7A18.493,18.493,0,0,0,15.859,34.473L19.2,35.957a.43.43,0,0,0,.356,0l3.338-1.484A18.493,18.493,0,0,0,33.865,17.587v-2.6a1.317,1.317,0,1,1,2.635,0v2.6A21.131,21.131,0,0,1,23.96,36.881l-3.337,1.484A3.066,3.066,0,0,1,19.375,38.629Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnByCollaboration);
export default __webpack_public_path__ + "static/media/learn-by-collaboration.9773374331f7521d96c808c0b93c1b70.svg";
export { ForwardRef as ReactComponent };